import React from 'react';
import './index.css';

// 归档文章项组件 - 独立抽离，保留所有小狗主题样式和交互
const ArchiveItem = ({ 
  post, 
  getMonthName, 
  handleTagSelect 
}) => {
  // 格式化日期
  const postDate = new Date(post.createdAt);
  const month = getMonthName(postDate.getMonth() + 1);
  const day = postDate.getDate();

  return (
    <div className="article-item">
      <div className="article-date">
        <span className="date-month">{month}</span>
        <span className="date-day">{day}</span>
      </div>
      <div className="article-content">
        <h4 className="article-title">{post.title}</h4>
        <p className="article-excerpt">{post.excerpt}</p>
        <div className="article-meta">
          <span className="meta-category" style={{ background: post.categoryColor }}>
            {post.category}
          </span>
          <span className="meta-views">👁️ {post.views}</span>
          <span className="meta-likes">❤️ {post.likes}</span>
          <span className="meta-comments">💬 {post.comments}</span>
        </div>
        <div className="article-tags">
          {post.tags?.map(tag => (
            <span key={tag} className="article-tag" onClick={() => handleTagSelect(tag)}>
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArchiveItem;